import { render, staticRenderFns } from "./imageButton.vue?vue&type=template&id=49b049e1&scoped=true&"
import script from "./imageButton.vue?vue&type=script&lang=js&"
export * from "./imageButton.vue?vue&type=script&lang=js&"
import style0 from "./imageButton.vue?vue&type=style&index=0&id=49b049e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b049e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
